// Institution types
export const institutionTypes = {
  'high-school': {
    type: 'high-school',
    singular: 'High School',
    plural: 'High Schools',
    example: 'Lincoln High, Stockton, CA'
  },
  'community-college': {
    type: 'community-college',
    singular: 'Community College',
    plural: 'Community Colleges',
    example: 'Dean College, Franklin, MA'
  }
};

// Button colors
export const buttonColors = [
  'primary',
  'blue',
  'light-blue',
  'alternate',
  'white',
  'gray',
  'negative',
  'red',
  'google',
  'gray-link'
];

// Default storybook-backgrounds-addon config
export const storybookBackgrounds = [
  {name: 'White', value: '#ffffff', default: true},
  {name: 'N50', value: '#f7f8f9'},
  {name: 'N100', value: '#f1f2f3'},
  {name: 'N900', value: '#313a42'},
  {name: 'B500', value: '#366aff'},
  {name: 'B50', value: '#ecf5ff'},
];

// Default storybook-host-addon config
export const storybookHostConfig = {
  align: 'center middle',
  backdrop: 'transparent'
};
